// import { TableOfContentsBlock } from "../types/tableOfContents.types";

export const TableOfContents = () => (
  <div className="p-2 bg-gray-100 rounded-md my-5">TOC Placeholder</div>
);
